import { gql } from '@apollo/client';
import { PRICING_OVERRIDE_FIELDS } from '@/graphql/fragments/pricing_overrides';

export const QUERY_USERS = gql`
    query Users {
        users {
            email
            username
            user_id
            roles
            shipper {
                approved
                test_acc
            }
            carrier {
                approved
                test_acc
            }
        }
    }
`;

export const QUERY_USERS_BY_ROLE = gql`
    ${PRICING_OVERRIDE_FIELDS}
    query UsersByRole($includeOrgAdmins: Boolean!) {
        orgAdmins: organizations(order_by: { name: asc }, where: { users: { roles: { _has_key: "ADMIN" } } })
            @include(if: $includeOrgAdmins) {
            organization_id
            name
            users(order_by: { email: asc }, where: { roles: { _has_key: "ADMIN" } }) {
                user_id
                email
            }
        }
        shippers: clients(
            order_by: { client_id: asc }
            where: { deactivated: { _neq: true }, user: { roles: { _has_key: "SHIPPER" } } }
        ) {
            client_id
            approved
            test_acc
            business_name
            partnerships_enabled
            user {
                user_id
                username
                email
                roles
            }
        }
        carriers: clients(
            order_by: { client_id: asc }
            where: {
                _and: [
                    { deactivated: { _neq: true } }
                    {
                        _or: [
                            { user: { roles: { _has_key: "CARRIER" } } }
                            { user: { roles: { _has_key: "CONTRACTOR" } } }
                        ]
                    }
                ]
            }
        ) {
            client_id
            approved
            test_acc
            business_name
            partnerships_enabled
            user {
                user_id
                username
                email
                roles
            }
            locations {
                location_id
                business_zip
            }
            pricing_overrides(where: { organization_id: { _is_null: true } }) {
                ...PricingOverrideFields
            }
        }

        teammates(order_by: { teammate_id: asc }, where: { team_leader_id: { _is_null: false } }) {
            team_leader_type
            teammate_id
            user {
                user_id
                username
                email
                roles
            }
        }
    }
`;
